import http from "../../../global/http"
import { CustomPackaging } from "../../../model/customPackaging"
import { ICustomPackaging } from "../../../model/interface/ICustomPackaging"

/** Shared by the list GET and the upload POST (which returns the full list). */
export const mapCustomPackagingList = (result: unknown) => {
  let customData: ICustomPackaging[] = []
  let totalCount = 0
  if (Array.isArray(result) && result.length > 0) {
    result.forEach((element) => {
      customData.push(new CustomPackaging().Deserialize(element))
    })
    totalCount = customData.length
    // keep only the most recent 12
    customData = customData.splice(0, 12)
  }
  return {
    records: customData,
    totalCount,
  }
}

export const getCustomPackagingListService = async (orgId: string) => {
  try {
    const rs: any = await http.get(
      `/user-mgmt/v2/org/${orgId}/account/custom-box`,
    )
    return mapCustomPackagingList(
      rs && rs.status === 200 ? rs.data.result : [],
    )
  } catch (err) {
    return err
  }
}

export const uploadNewCustomBoxService = async (
  orgId: string,
  formData: FormData,
) => {
  const url = `/user-mgmt/v2/org/${orgId}/account/custom-box/`
  try {
    const res = http.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    return res
  } catch (err) {
    return err
  }
}

export const downloadCustomBoxFiles = async (
  orgId: string,
  accountId: string | undefined,
  imageType: "top" | "side" | "box",
) => {
  const url = `/user-mgmt/v2/org/${orgId}/account/custom-box/${accountId}/${imageType}/`
  try {
    const res = await http.get(url, {
      responseType: "blob",
    })
    return res
  } catch (err) {
    return err
  }
}
